import Styled from 'styled-components';

export const ItemNote = Styled.div`
    color: #A5A5AE;
`;

export const SkillsPreview = Styled.div`
    padding-top: 16px;
`;
